
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("iihQ1"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("iihQ1", function(module, exports) {

let $d517beb79ab70780$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d517beb79ab70780$var$load("iNoxQ"),
    $d517beb79ab70780$var$load("lOm4J"),
    $d517beb79ab70780$var$load("8thxw"),
    $d517beb79ab70780$var$load("7FMMX"),
    $d517beb79ab70780$var$load("eRhBr"),
    $d517beb79ab70780$var$load("6HpsR"),
    $d517beb79ab70780$var$load("N3oqb"),
    $d517beb79ab70780$var$load("hZ2FX"),
    $d517beb79ab70780$var$load("9ZFGK"),
    $d517beb79ab70780$var$load("2hLAI"),
    $d517beb79ab70780$var$load("dCilB"),
    $d517beb79ab70780$var$load("h1yOv"),
    $d517beb79ab70780$var$load("1T8H1"),
    $d517beb79ab70780$var$load("fyKFO"),
    $d517beb79ab70780$var$load("d9sg7"),
    $d517beb79ab70780$var$load("l0N35"),
    $d517beb79ab70780$var$load("bU9L5"),
    $d517beb79ab70780$var$load("fuOfV"),
    $d517beb79ab70780$var$load("iZR3N"),
    $d517beb79ab70780$var$load("4zz48"),
    $d517beb79ab70780$var$load("jXM1T"),
    $d517beb79ab70780$var$load("cvcNg"),
    $d517beb79ab70780$var$load("jw3lv"),
    $d517beb79ab70780$var$load("7rqWx"),
    $d517beb79ab70780$var$load("aIze1"),
    $d517beb79ab70780$var$load("il8bj"),
    $d517beb79ab70780$var$load("4N1MY"),
    $d517beb79ab70780$var$load("kG5Ju"),
    $d517beb79ab70780$var$load("39XCn"),
    $d517beb79ab70780$var$load("3Cky6"),
    $d517beb79ab70780$var$load("jL1Ke"),
    $d517beb79ab70780$var$load("5MQ0D"),
    $d517beb79ab70780$var$load("aFLSJ"),
    $d517beb79ab70780$var$load("6fJCf"),
    $d517beb79ab70780$var$load("duEFL"),
    $d517beb79ab70780$var$load("6wr18"),
    $d517beb79ab70780$var$load("1pJPT"),
    $d517beb79ab70780$var$load("8zMmc"),
    $d517beb79ab70780$var$load("4x9Jx"),
    $d517beb79ab70780$var$load("7EorR"),
    $d517beb79ab70780$var$load("ffEVr"),
    $d517beb79ab70780$var$load("2EIkU"),
    $d517beb79ab70780$var$load("Wowvf"),
    $d517beb79ab70780$var$load("hhss7"),
    $d517beb79ab70780$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("2w2M9"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("2w2M9", function(module, exports) {

let $1d50b91b47970ad7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1d50b91b47970ad7$var$load("8thxw"),
    $1d50b91b47970ad7$var$load("7FMMX"),
    $1d50b91b47970ad7$var$load("6wr18"),
    $1d50b91b47970ad7$var$load("ffEVr"),
    $1d50b91b47970ad7$var$load("g33mJ"),
    $1d50b91b47970ad7$var$load("jQyKx"),
    $1d50b91b47970ad7$var$load("2EIkU"),
    $1d50b91b47970ad7$var$load("eRhBr"),
    $1d50b91b47970ad7$var$load("hZ2FX"),
    $1d50b91b47970ad7$var$load("hhss7"),
    $1d50b91b47970ad7$var$load("kT6dz"),
    $1d50b91b47970ad7$var$load("aAWLw"),
    $1d50b91b47970ad7$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("lbybQ"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("lbybQ", function(module, exports) {

let $f6c52578b917371f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f6c52578b917371f$var$load("4ZKBo"),
    $f6c52578b917371f$var$load("3WmaY"),
    $f6c52578b917371f$var$load("7gL7H"),
    $f6c52578b917371f$var$load("7TnhR"),
    $f6c52578b917371f$var$load("hUbK8"),
    $f6c52578b917371f$var$load("68hpv"),
    $f6c52578b917371f$var$load("1r4R9"),
    $f6c52578b917371f$var$load("bx5S2"),
    $f6c52578b917371f$var$load("7fsAO"),
    $f6c52578b917371f$var$load("knuqf"),
    $f6c52578b917371f$var$load("ipIDQ"),
    $f6c52578b917371f$var$load("agv3Q"),
    $f6c52578b917371f$var$load("garBx"),
    $f6c52578b917371f$var$load("0jVJ8"),
    $f6c52578b917371f$var$load("fDpJx"),
    $f6c52578b917371f$var$load("3bz2q"),
    $f6c52578b917371f$var$load("eRcQY"),
    $f6c52578b917371f$var$load("by6h6"),
    $f6c52578b917371f$var$load("j3345"),
    $f6c52578b917371f$var$load("2J2X1"),
    $f6c52578b917371f$var$load("7xLM7"),
    $f6c52578b917371f$var$load("Mjfig"),
    $f6c52578b917371f$var$load("e7Dyr"),
    $f6c52578b917371f$var$load("cPAXo"),
    $f6c52578b917371f$var$load("44j0l"),
    $f6c52578b917371f$var$load("6hYei"),
    $f6c52578b917371f$var$load("fJEib"),
    $f6c52578b917371f$var$load("46GUH"),
    $f6c52578b917371f$var$load("dxcsb"),
    $f6c52578b917371f$var$load("gbejv"),
    $f6c52578b917371f$var$load("GD9EA"),
    $f6c52578b917371f$var$load("2hLAI"),
    $f6c52578b917371f$var$load("dCilB"),
    $f6c52578b917371f$var$load("1T8H1"),
    $f6c52578b917371f$var$load("fyKFO"),
    $f6c52578b917371f$var$load("d9sg7"),
    $f6c52578b917371f$var$load("l0N35"),
    $f6c52578b917371f$var$load("iNoxQ"),
    $f6c52578b917371f$var$load("lOm4J"),
    $f6c52578b917371f$var$load("9LVeR"),
    $f6c52578b917371f$var$load("8exG0"),
    $f6c52578b917371f$var$load("gnocL"),
    $f6c52578b917371f$var$load("kT6dz"),
    $f6c52578b917371f$var$load("8thxw"),
    $f6c52578b917371f$var$load("7FMMX"),
    $f6c52578b917371f$var$load("6wr18"),
    $f6c52578b917371f$var$load("bsVN9"),
    $f6c52578b917371f$var$load("hZVEi"),
    $f6c52578b917371f$var$load("fcsnw"),
    $f6c52578b917371f$var$load("ffEVr"),
    $f6c52578b917371f$var$load("g33mJ"),
    $f6c52578b917371f$var$load("jQyKx"),
    $f6c52578b917371f$var$load("ddvkk"),
    $f6c52578b917371f$var$load("3upHR"),
    $f6c52578b917371f$var$load("hhss7"),
    $f6c52578b917371f$var$load("Wowvf"),
    $f6c52578b917371f$var$load("eRhBr"),
    $f6c52578b917371f$var$load("hZ2FX"),
    $f6c52578b917371f$var$load("cKDij"),
    $f6c52578b917371f$var$load("7EorR"),
    $f6c52578b917371f$var$load("ce05o"),
    $f6c52578b917371f$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.86ec2a39.js.map
